export const TWO_FACTOR_STATUS = {
    DISABLED: 'disabled',
    PENDING_VERIFICATION: 'pending_verification',
    ENABLED: 'enabled'
} as const;

export type TwoFactorStatusValue = typeof TWO_FACTOR_STATUS[keyof typeof TWO_FACTOR_STATUS];

/**
 * Temporary kill-switch for 2FA enforcement (modal + forced redirect).
 * Flip to `true` to re-enable. Used in `useGet2FAEnforcementStatus`.
 */
export const IS_2FA_ENFORCEMENT_ENABLED = true;
